var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStrategicEnablersOutlined(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/status-up"
  }, /*#__PURE__*/React.createElement("g", {
    id: "status-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.87988 14.3301C6.2941 14.3301 6.62988 14.6659 6.62988 15.0801V17.1501C6.62988 17.5643 6.2941 17.9001 5.87988 17.9001C5.46567 17.9001 5.12988 17.5643 5.12988 17.1501V15.0801C5.12988 14.6659 5.46567 14.3301 5.87988 14.3301Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 12.26C11.4142 12.26 11.75 12.5958 11.75 13.01V17.15C11.75 17.5642 11.4142 17.9 11 17.9C10.5858 17.9 10.25 17.5642 10.25 17.15V13.01C10.25 12.5958 10.5858 12.26 11 12.26Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1201 10.1799C16.5343 10.1799 16.8701 10.5157 16.8701 10.9299V17.1499C16.8701 17.5641 16.5343 17.8999 16.1201 17.8999C15.7059 17.8999 15.3701 17.5641 15.3701 17.1499V10.9299C15.3701 10.5157 15.7059 10.1799 16.1201 10.1799Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6064 4.27918C16.9217 4.54778 16.9596 5.02115 16.691 5.33646L16.2299 5.87773C13.5782 8.97663 10.0222 11.1703 6.06151 12.1578C5.6596 12.258 5.25255 12.0135 5.15234 11.6116C5.05213 11.2097 5.2967 10.8026 5.69861 10.7024C9.35766 9.79003 12.6415 7.76385 15.0898 4.90303C15.0896 4.90321 15.0899 4.90285 15.0898 4.90303L15.5491 4.36376C15.8177 4.04844 16.2911 4.01058 16.6064 4.27918Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4399 4.8501C12.4399 4.43588 12.7757 4.1001 13.1899 4.1001H16.1199C16.5342 4.1001 16.8699 4.43588 16.8699 4.8501V7.7701C16.8699 8.18431 16.5342 8.5201 16.1199 8.5201C15.7057 8.5201 15.3699 8.18431 15.3699 7.7701V5.6001H13.1899C12.7757 5.6001 12.4399 5.26431 12.4399 4.8501Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.09467 2.09467C3.42914 0.760201 5.42603 0.25 8 0.25H14C16.574 0.25 18.5709 0.760201 19.9053 2.09467C21.2398 3.42914 21.75 5.42603 21.75 8V14C21.75 16.574 21.2398 18.5709 19.9053 19.9053C18.5709 21.2398 16.574 21.75 14 21.75H8C5.42603 21.75 3.42914 21.2398 2.09467 19.9053C0.760201 18.5709 0.25 16.574 0.25 14V8C0.25 5.42603 0.760201 3.42914 2.09467 2.09467ZM3.15533 3.15533C2.2398 4.07086 1.75 5.57397 1.75 8V14C1.75 16.426 2.2398 17.9291 3.15533 18.8447C4.07086 19.7602 5.57397 20.25 8 20.25H14C16.426 20.25 17.9291 19.7602 18.8447 18.8447C19.7602 17.9291 20.25 16.426 20.25 14V8C20.25 5.57397 19.7602 4.07086 18.8447 3.15533C17.9291 2.2398 16.426 1.75 14 1.75H8C5.57397 1.75 4.07086 2.2398 3.15533 3.15533Z",
    fill: "#7C7C7C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategicEnablersOutlined);
export default __webpack_public_path__ + "static/media/strategicEnablersOutlined.ba3137f2ac7ac11d02d5277f4afe18eb.svg";
export { ForwardRef as ReactComponent };